import { TypeOf, yup } from '@guiker/shared-framework'

import { AccountHolderType } from '../../../../entity'

export const accountHolderTypeSchema = yup.mixed<AccountHolderType>().oneOf(Object.values(AccountHolderType)).required()

export type AccountHolderTypeSchema = TypeOf<typeof accountHolderTypeSchema>
